import { CommandJob } from "~/components/build/Show/lib/types";
import PipelineStateIcon, {
  colorForJob,
} from "~/components/shared/PipelineStateIcon/PipelineStateIcon";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { resolveJobUrl } from "~/components/build/Show/lib/urlForView";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { isJobIgnored } from "~/components/build/Show/lib/isJobIgnored";
import { jobQueryOptions } from "~/components/build/Show/lib/queries/job";
import { usePrefetchHandlers } from "~/components/build/Show/lib/usePrefetchHandlers";

interface Props {
  job: CommandJob;
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const JobPillLink = ({ job, children, className, onClick }: Props) => {
  const { build } = useBuild();

  const pillContent = (
    <>
      {children}

      <PipelineStateIcon
        job={job}
        className={classNames("block shrink-0", colorForJob(job, build))}
        style={{ width: "14px", height: "14px" }}
      />
    </>
  );

  const pillClassName = twMerge(
    "px-3 py-1.5",
    "text-charcoal-700 flex items-center gap-1.5 rounded-lg border border-slate-500 bg-white transition-colors",
    classNames({
      "border-lime-500": job.state === "finished" && job.passed,
      "border-red-500 bg-red-100": job.state === "finished" && !job.passed,
      "border-orange-500 bg-orange-100": job.state === "running",
      "opacity-60": isJobIgnored(job),
      "hover:text-charcoal-700 hover:text-current hover:no-underline focus:text-current focus:no-underline active:text-current active:shadow-inner": true,
    }),
    className,
  );

  const { onMouseEnter, onMouseLeave } = usePrefetchHandlers({
    queries: [jobQueryOptions(build, job.id)],
    enabled: Features.ProgressiveBuildShow,
  });

  return (
    <Link
      onClick={onClick}
      to={resolveJobUrl(job.id, { open: !isJobIgnored(job) })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      key={job.id}
      className={pillClassName}
    >
      {pillContent}
    </Link>
  );
};
